<template>
  <v-sheet
    color="primary darken-1"
    width="100%"
    :height="xs ? `50px` : `64px`"
    class="d-flex align-center"
  >
    <v-container>
      <div
        class="
          white--text
          text-h6 text-sm-h5 text-md-h4 text-lg-h3
          font-weight-medium
        "
      >
        <slot />
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>
